<template>
  <div class="radio">
    <base-button class="radio__add" v-if="!shouldAddRadio" @click="shouldAddRadio = true">Add track</base-button>
    <transition-group name="list" mode="out-in" class="radio__list" tag="ul">
      <app-radio-cell v-if="shouldAddRadio" key="add" class="list__radio" @close="shouldAddRadio = false" />
      <app-radio-cell v-for="track in tracks" :key="track.id" :radio="track" class="list__radio" />
    </transition-group>
  </div>
</template>

<script lang="ts">
import AppRadioCell from '@/components/RadioCell.vue';
import gql from 'graphql-tag';
import { Component, Vue } from 'vue-property-decorator';
import { RadioFragments } from '../apollo/fragments/radio';
import { Radio } from '../types/api';

@Component({
  components: { AppRadioCell },
  apollo: {
    tracks: {
      query: gql`
        query Tracks {
          tracks {
            ...Radio
          }
        }
        ${RadioFragments.Radio}
      `,
      fetchPolicy: 'cache-and-network',
    },
  },
})
export default class RadioView extends Vue {
  tracks: Radio[] = [];
  shouldAddRadio = false;
}
</script>

<style lang="scss" scoped>
.radio {
  &__add {
    margin-bottom: 8px;
  }
}

.list__radio {
  &:not(:last-child) {
    margin-bottom: 8px;
  }
}
</style>
